import { NgModule } from '@angular/core';
import { PayperiodLockoutService } from './payperiod-lockout.service';
import { PayperiodLockoutBackend } from './payperiod-lockout.backend';

@NgModule({
  providers: [PayperiodLockoutService, PayperiodLockoutBackend],
})
export class PayperiodLockoutModule {}
